<div class="factory-reset-v2">
	<button
		type="button"
		class="factory-reset-v2-close"
		(click)="dismiss(false)"
		[attr.aria-label]="'NOTE_EDITOR__CLOSE' | transloco"
	>
		<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">close</span>
	</button>

	<div class="factory-reset-v2-header">
		<h2 class="factory-reset-v2-title">{{ "FACTORY_RESET__TITLE" | transloco }}</h2>
		<p class="factory-reset-v2-description">{{ "FACTORY_RESET__DESCRIPTION" | transloco }}</p>
	</div>

	<div class="factory-reset-v2-actions">
		<button type="button" class="factory-reset-v2-cancel" (click)="dismiss(false)">
			{{ "FACTORY_RESET__CANCEL" | transloco }}
		</button>
		<button type="button" class="factory-reset-v2-ok" (click)="dismiss(true)">
			{{ "FACTORY_RESET__OK" | transloco }}
		</button>
	</div>
</div>
